import {
  all, call, put, takeLatest,
} from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';

import showNotification from 'services/utils/showNotification';
import { getAngelInvestorMemberById } from 'packages/people_repository';
import { IdPayload } from 'types/reduxTypes/ActionTypes';
import { identity } from 'utils';
import {
  setAngelInvestorMemberById,
  types,
} from '../../actions/angelInvestorMemberDetails';

export function * handleGetAngelInvestorMemberById(action: PayloadAction<IdPayload>) {
  const { id } = action.payload;

  const { data: member, error, httpStatus } = yield call(getAngelInvestorMemberById, id);

  if (identity.isObjWithChildren(error)) {
    showNotification(`Something went wrong: ${error.message}`, true, httpStatus);
  }

  yield put(setAngelInvestorMemberById({ member }));
}

export default function * angelInvestorMemberDetailsSagas() {
  yield all([
    takeLatest(types.GET_ANGEL_INVESTOR_MEMBER_BY_ID, handleGetAngelInvestorMemberById),
  ]);
}
